export const landingPageInitialState = {
  selectedTab: "drafts",
  // Device/viewport flags set at runtime from DelLandingPage
  isTouch: false,
  isTablet: false,
  viewportWidth: 0,
  viewportHeight: 0,
};
